import AnalyticsProvider from "AnalyticsDashboard/components/AnalyticsProvider";
import QueryBuilderPanel from "AnalyticsDashboard/components/QueryBuilderPanel";

export default function NewAnalytics() {
  return (
    <div className="analytics">
      <AnalyticsProvider>
        <QueryBuilderPanel />
      </AnalyticsProvider>
    </div>
  );
}
